import { FieldPath, FieldValues, UseControllerProps } from 'react-hook-form';

export const parseRulesForInputAttributes = <
    TFieldValues extends FieldValues,
    TName extends FieldPath<TFieldValues>,
>(
    rules: UseControllerProps<TFieldValues, TName>['rules'],
) => {
    return {
        minLength: typeof rules?.minLength === 'object' ? rules.minLength.value : rules?.minLength,
        maxLength: typeof rules?.maxLength === 'object' ? rules.maxLength.value : rules?.maxLength,
        min: typeof rules?.min === 'object' ? rules.min.value : rules?.min,
        max: typeof rules?.max === 'object' ? rules.max.value : rules?.max,
        required: !!rules?.required,
    };
};
